import React from 'react';
import { TextField } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import { Controller, useFormContext } from 'react-hook-form';
import { useConditionalVisibility } from '../../../_hooks/useConditionalVisibility';

const CustomNumericField = ({ question }) => {
    const { label, size = "small",fieldId,disable, rules,defaultValue, isAllowedFn, isHidden} = question;
    const {control, formState: { errors }} = useFormContext();  
    const isVisible = useConditionalVisibility(question.dependantConditions );
    if (!isVisible && isHidden) return null;
  
  return (
    <Controller
      name={fieldId}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field }) => (
        <NumericFormat
           value={field.value ?? ''}
           isAllowed={(values) => isAllowedFn?.(values.value) ?? true}
          onValueChange={({ floatValue }) => {
            field.onChange(floatValue ?? '');
          }}
          customInput={TextField}
          fullWidth
          label={label}
          error={!!errors[fieldId]}
          helperText={errors[fieldId]?.message}
          disabled={disable}
          size={size}
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          allowNegative={false}
          fixedDecimalScale={true}
          thousandSeparator="."
          decimalSeparator=","
          decimalScale={2}
        />
      )}
    />
  );
};

export default CustomNumericField;
